import React, { useEffect, useState } from "react";
import { collection, getDocs, doc, setDoc } from "firebase/firestore";
import { db } from "../firebase";

export default function BookmarkExportView({ user, onBack, reloadCallback }) {
  const [videos, setVideos] = useState({});
  const [selected, setSelected] = useState({});

  useEffect(() => {
    if (!user) return;
    const fetchData = async () => {
      const videoCol = collection(db, "users", user.uid, "videos");
      const videoSnap = await getDocs(videoCol);
      const result = {};

      for (const docSnap of videoSnap.docs) {
        const videoId = docSnap.id;
        const videoData = docSnap.data();
        const sectionCol = collection(db, "users", user.uid, "videos", videoId, "bookmarks");
        const sectionSnap = await getDocs(sectionCol);
        const sections = sectionSnap.docs.map(d => ({ id: d.id, ...d.data() }));
        result[videoId] = { title: videoData.title, sections };
      }
      setVideos(result);
    };
    fetchData();
  }, [user]);

  const toggleSelection = (videoId, sectionId) => {
    setSelected(prev => {
      const key = `${videoId}|${sectionId}`;
      const copy = { ...prev };
      if (copy[key]) delete copy[key];
      else copy[key] = true;
      return copy;
    });
  };

  const handleExport = () => {
    const exportData = [];
    for (const [videoId, { title, sections }] of Object.entries(videos)) {
      for (const section of sections) {
        const key = `${videoId}|${section.id}`;
        if (selected[key]) {
          exportData.push({ videoId, videoTitle: title, ...section });
        }
      }
    }
    const blob = new Blob([JSON.stringify(exportData, null, 2)], { type: "application/json" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = "loopy_export.json";
    link.click();
  };

  const handleCreateShareLink = async () => {
    const exportData = [];
    for (const [videoId, { title, sections }] of Object.entries(videos)) {
      for (const section of sections) {
        const key = `${videoId}|${section.id}`;
        if (selected[key]) {
          exportData.push({ videoId, videoTitle: title, ...section });
        }
      }
    }

    if (!exportData.length) {
      alert("No sections selected");
      return;
    }

    const newDocRef = doc(collection(db, "sharedExports"));
    await setDoc(newDocRef, {
      createdAt: Date.now(),
      data: exportData,
    });

    const shareUrl = `${window.location.origin}/shared/${newDocRef.id}`;
    await navigator.clipboard.writeText(shareUrl);
    alert("Link copied to clipboard:\n" + shareUrl);
  };

  return (
    <div className="space-y-4">
      <h3 className="text-lg font-semibold">Select Sections to Export</h3>
      {Object.entries(videos).map(([vid, data]) => (
        <div key={vid} className="border p-2 rounded">
          <strong>{data.title}</strong>
          <ul className="ml-4 mt-2 space-y-1">
            {data.sections.map(sec => (
              <li key={sec.id}>
                <label className="flex items-center gap-2">
                  <input
                    type="checkbox"
                    checked={!!selected[`${vid}|${sec.id}`]}
                    onChange={() => toggleSelection(vid, sec.id)}
                  />
                  <span>
                    {sec.title} ({sec.start.toFixed(1)}–{sec.end.toFixed(1)}s @ {sec.speed.toFixed(2)}x)
                  </span>
                </label>
              </li>
            ))}
          </ul>
        </div>
      ))}
      <div className="flex gap-2">
        <button className="bg-gray-400 text-white px-4 py-2 rounded" onClick={() => { onBack(); reloadCallback?.(); }}>Back</button>
        <button className="bg-blue-600 text-white px-4 py-2 rounded" onClick={handleExport}>Export as File</button>
        <button className="bg-purple-600 text-white px-4 py-2 rounded" onClick={handleCreateShareLink}>Create Share Link</button>
      </div>
    </div>
  );
}
